/**
 * Presentational: empty state when no facilities are found in the list.
 * Single Responsibility: render message only; copy from constants.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { PAGE_COPY } from '../constants';

const WRAPPER_CLASS = 'flex flex-col items-center justify-center gap-4 py-12';
const MESSAGE_CLASS = 'text-gray-500 font-[\'Roboto:Regular\',sans-serif] text-center';

export function FacilitiesEmptyState({
  message = PAGE_COPY.EMPTY_FACILITIES_MESSAGE,
}) {
  return (
    <div className={WRAPPER_CLASS}>
      <p className={MESSAGE_CLASS}>{message}</p>
    </div>
  );
}

FacilitiesEmptyState.propTypes = {
  message: PropTypes.string,
};
